import { StyleSheet, Platform } from 'react-native';
import { theme } from '../../../theme';

export const challengeDetailScreenStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.gray[100],
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: theme.white,
    borderBottomWidth: 1,
    borderBottomColor: theme.gray[200],
  },
  backButton: {
    padding: 8,
  },
  backButtonPressed: {
    opacity: 0.7,
  },
  backButtonHover: {
    opacity: 0.85,
  },
  backText: {
    fontSize: 16,
    color: theme.primary,
    fontWeight: '500',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.gray[900],
  },
  headerRight: {
    width: 60,
  },
  infoCard: {
    backgroundColor: theme.white,
    margin: 16,
    borderRadius: 12,
    padding: 16,
    shadowColor: theme.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  challengeHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  trophy: {
    fontSize: 24,
    marginRight: 12,
  },
  challengeInfo: {
    flex: 1,
    marginRight: 12,
  },
  challengeName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.gray[900],
    marginBottom: 4,
  },
  challengeDescription: {
    fontSize: 14,
    color: theme.gray[600],
    lineHeight: 20,
  },
  keyStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
    paddingVertical: 12,
    backgroundColor: theme.gray[100],
    borderRadius: 8,
  },
  statBox: {
    alignItems: 'center',
  },
  statNumber: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.gray[900],
    marginBottom: 2,
  },
  statLabel: {
    fontSize: 12,
    color: theme.gray[600],
  },
  scoringSection: {
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: theme.gray[900],
    marginBottom: 12,
  },
  scoringRules: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  scoringRule: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  scoringIcon: {
    fontSize: 16,
    marginRight: 6,
  },
  scoringText: {
    fontSize: 13,
    color: theme.gray[600],
  },
  section: {
    margin: 16,
  },
  leaderboard: {
    backgroundColor: theme.white,
    borderRadius: 12,
    padding: 16,
    shadowColor: theme.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  leaderboardItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: theme.gray[100],
  },
  rankContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: 60,
  },
  rankNumber: {
    fontSize: 16,
    fontWeight: 'bold',
    color: theme.gray[900],
  },
  crown: {
    fontSize: 16,
    marginLeft: 4,
  },
  participantInfo: {
    flex: 1,
    marginLeft: 12,
  },
  participantName: {
    fontSize: 14,
    fontWeight: '500',
    color: theme.gray[900],
  },
  participantStats: {
    fontSize: 12,
    color: theme.gray[600],
  },
  participantPoints: {
    fontSize: 14,
    fontWeight: 'bold',
    color: theme.gray[900],
  },
  matchCard: {
    backgroundColor: theme.white,
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: theme.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  matchHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  matchDate: {
    fontSize: 14,
    color: theme.gray[600],
  },
  matchTeams: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  teamName: {
    fontSize: 16,
    fontWeight: '500',
    color: theme.gray[900],
    flex: 1,
    textAlign: 'center',
  },
  vsText: {
    fontSize: 16,
    color: theme.primary,
    fontWeight: '700',
    marginHorizontal: 12,
  },
  matchScore: {
    alignItems: 'center',
    marginBottom: 8,
  },
  scoreText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.gray[900],
  },
  predictionCard: {
    backgroundColor: '#F0F9FF',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
  },
  predictionLabel: {
    fontSize: 12,
    color: '#0369A1',
    marginBottom: 4,
  },
  predictionText: {
    fontSize: 14,
    color: '#0C4A6E',
    fontWeight: '500',
  },
  pointsEarned: {
    marginTop: 4,
  },
  pointsText: {
    fontSize: 12,
    color: theme.success,
    fontWeight: 'bold',
  },
  predictButton: {
    backgroundColor: theme.primary,
    borderRadius: 8,
    padding: 12,
    alignItems: 'center',
  },
  predictButtonText: {
    color: theme.white,
    fontSize: 14,
    fontWeight: '500',
  },
  predictButtonPressed: {
    opacity: 0.8,
  },
  predictButtonHover: {
    opacity: 0.9,
  },
  actionsSection: {
    flexDirection: 'row',
    padding: 12,
    paddingBottom: 16,
    gap: 12,
    backgroundColor: theme.background.card,
    borderTopWidth: 1,
    borderTopColor: theme.gray[200],
    ...(Platform.OS === 'web'
      ? { boxShadow: '0px -2px 12px rgba(0,0,0,0.07)' as const }
      : {
          shadowColor: theme.black,
          shadowOffset: { width: 0, height: -2 },
          shadowOpacity: 0.07,
          shadowRadius: 10,
          elevation: 6,
        }),
  },
  actionButton: {
    flex: 1,
    backgroundColor: theme.primary,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
  },
  actionButtonText: {
    color: theme.white,
    fontSize: 14,
    fontWeight: '700',
  },
  actionButtonSecondary: {
    flex: 1,
    backgroundColor: theme.gray[100],
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: theme.gray[200],
    minHeight: 40,
  },
  actionButtonSecondaryText: {
    color: theme.gray[700],
    fontSize: 14,
    fontWeight: '600',
  },
  actionButtonPressed: {
    opacity: 0.8,
  },
  actionButtonHover: {
    opacity: 0.9,
  },
  actionButtonSecondaryPressed: {
    opacity: 0.8,
  },
  actionButtonSecondaryHover: {
    opacity: 0.9,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.gray[100],
  },
  errorText: {
    fontSize: 16,
    color: theme.gray[700],
    marginBottom: 16,
  },
  backButtonText: {
    fontSize: 16,
    color: theme.white,
    marginLeft: 8,
  },
  errorBackButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: theme.primary,
    borderRadius: 8,
  },
  errorBackButtonPressed: {
    opacity: 0.8,
  },
  errorBackButtonHover: {
    opacity: 0.9,
  },
  screenContainer: {
    flex: 1,
    backgroundColor: theme.gray[100],
  },
  loadingMoreDetailsBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 16,
    backgroundColor: theme.gray[200],
  },
  loadingMoreDetailsText: {
    fontSize: 12,
    color: theme.gray[600],
    marginLeft: 6,
  },
  headerBackButton: {
    position: 'absolute',
    top: 48,
    left: 16,
    zIndex: 10,
    padding: 8,
    backgroundColor: theme.white,
    borderRadius: 24,
    shadowColor: theme.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  headerBackButtonPressed: { opacity: 0.7 },
  headerBackButtonHover: { opacity: 0.9 },
});

